import InfiniteScroll from "react-infinite-scroll-component";
import { t } from "@/i18n-js/instance";
import { useNearMeFilter } from "@/react/components/shared/MemberFilters/SharedFilters/NearMe/useNearMeFilter";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import type { UseSelectMembersInfiniteQuery } from "../hooks/useSelectMembersInfiniteQuery";
import { MemberCard } from "./MemberCard";

interface CardViewProps {
  memberDataParams: UseSelectMembersInfiniteQuery;
}

export const CardView = ({ memberDataParams }: CardViewProps) => {
  const { members, fetchNextPage, hasNextPage, dataLength } = memberDataParams;

  const { nearMeFilter, isNearMeActive } = useNearMeFilter();

  return (
    <>
      {isNearMeActive && (
        <div className="mb-6">
          <Typography.LabelSm weight="medium">
            {t("member_directory.near_me.title", {
              count: dataLength,
            })}
          </Typography.LabelSm>
          <Typography.BodyXs>{nearMeFilter?.value?.name}</Typography.BodyXs>
        </div>
      )}
      <InfiniteScroll
        style={{ overflow: "initial" }}
        scrollThreshold={0.8}
        next={fetchNextPage}
        hasMore={!!hasNextPage}
        loader={<Loader />}
        dataLength={members.length}
        scrollableTarget="panel"
      >
        <ol
          className /* Safari has an issue of overflowing content, this is added as a fix */="grid-cols-member-directory-grid-mobile md:grid-cols-member-directory-grid m-4 grid max-w-[-webkit-fill-available] list-none auto-rows-fr justify-center gap-6 md:m-0 lg:m-auto"
          data-testid="directory_members_grid"
        >
          {members.map(member => (
            <MemberCard key={member.id} member={member} />
          ))}
        </ol>
      </InfiniteScroll>
    </>
  );
};
